import { RETURN_CODES } from '../../data/Validators';

export default class LastAction {
  /**
   * Represents the last action performed on an asset, such as adding or removing it from the selection.
   * This class is used to track the type of action, the ID of the asset involved, and its type
   * (e.g., image, video). It helps in providing feedback to the user about their recent interactions
   * with assets in the selection step.
   * @param {string|null} type - The type of action performed (e.g., 'add', 'remove'), or null if no action.
   * @param {number|string|null} id - The ID of the asset involved in the action, or null if no asset.
   * @param {string|null} assetType - The type of the asset (e.g., 'image', 'video'), or null if no asset.
   */
  constructor(type = null, id = null, assetType = null) {
    this.type = type;
    this.id = id;
    this.assetType = assetType;
  }

  /**
   * Determines if the last action was adding the specified asset.
   * @param {number|string} assetId - The ID of the asset to check.
   * @param {string} assetType - The type of the asset to check.
   * @returns {boolean} True if the last action was adding the specified asset, false otherwise.
   */
  isJustAdded(assetId, assetType) {
    return (
      this.type === RETURN_CODES.OK &&
      String(this.id) === String(assetId) &&
      this.assetType === assetType
    );
  }

  /**
   * Determines if the last action was adding a duplicate of the specified asset.
   * @param {number|string} assetId - The ID of the asset to check.
   * @param {string} assetType - The type of the asset to check.
   * @returns {boolean} True if the last action was adding a duplicate of the specified asset, false otherwise.
   */
  isDuplicate(assetId, assetType) {
    return (
      this.type === RETURN_CODES.DUPLICATE_ASSET &&
      String(this.id) === String(assetId) &&
      this.assetType === assetType
    );
  }
}
